export default "__VITE_ASSET__CpAY4Tis__"